'use strict';

const PRODUCT_QUANTITY = {
	MAX_QUANTITY_LIMIT: 10000,
};

module.exports = { PRODUCT_QUANTITY };
